import { useRequest } from '@mgm/common/lib';
import { TAxiosError } from '@mgm/common/types';
import { CONTROLLERS } from '../utils/enums';
import {
  TAddTasklistReq, TDeleteTasklistsReq, TEditTasklistReq, TGetSubmissionsReq, TUpdateSubmissionReq,
} from '../types/requests';
import { TSubmission } from '../types';
import { BASE_URL } from '../../config';
import { getIdToken } from '../utils/helpers';

export function TasklistsController() {
  const {
    axiosRequest,
    initRequestOptions,
  } = useRequest(BASE_URL);

  const controllerName = CONTROLLERS.TASKLISTS;

  const getTasklists = <T>(data: { shopName: string }): Promise<T | { success: boolean; error: TAxiosError }> => {
    const options = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest(`${controllerName}/data`, options);
  };

  const getSubmissions = <T>(data: TGetSubmissionsReq): Promise<T | { success: boolean; error: TAxiosError }> => {
    const options = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest(`${controllerName}/submissions`, options);
  };

  const updateTasklist = <T>(data: TEditTasklistReq): Promise<T | { success: boolean; error: TAxiosError }> => {
    const options = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest(`${controllerName}/update`, options);
  };

  const dailySubmissions = <T>(data: {
    shopName: string;
    timezone: string;
  }): Promise<T | { success: boolean; error: TAxiosError }> => {
    const options = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest(`${controllerName}/daily_submissions`, options);
  };

  const deleteTasklist = <T>(data: TDeleteTasklistsReq): Promise<T | { success: boolean; error: TAxiosError }> => {
    const options = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest(`${controllerName}/delete`, options);
  };

  const addTasklist = <T>(data: TAddTasklistReq): Promise<T | { success: boolean; error: TAxiosError }> => {
    const options = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest(`${controllerName}/add`, options);
  };

  const submitTasklist = <T>(data: { submission: TSubmission }): Promise<T | { success: boolean; error: TAxiosError }> => {
    const options = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest(`${controllerName}/submit`, options);
  };

  const updateSubmission = <T>(data: TUpdateSubmissionReq): Promise<T | { success: boolean; error: TAxiosError }> => {
    const options = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest(`${controllerName}/update_submission`, options);
  };

  return {
    getTasklists,
    getSubmissions,
    dailySubmissions,
    deleteTasklist,
    updateTasklist,
    addTasklist,
    submitTasklist,
    updateSubmission,
  };
}
